// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.e-alert[data-v-75dbb402] {\n  text-align:left;\n  width: 350px;\n}\n.formbox[data-v-75dbb402] {position:relative; padding-left:120px;}\n.formbox>.tit[data-v-75dbb402] {position:absolute; left:0; top:0;}\n", ""]);
// Exports
module.exports = exports;
